import Badge, {BadgeColor} from './Badge';

export default function MqttConnectionBadge({label, className}: { label: string, className?: string }) {
    let color: BadgeColor;

    switch (label) {
        case 'Reconnecting':
            color = {
                bg: 'bg-yellow-50',
                text: 'text-yellow-800',
                ring: 'ring-yellow-600/20'
            }
            break;
        case 'Connected':
            color = {
                bg: 'bg-green-50',
                text: 'text-green-700',
                ring: 'ring-green-600/20'
            }
            break;
        default:
            color = {
                bg: 'bg-red-50',
                text: 'text-red-700',
                ring: 'ring-red-600/10'
            }
    }

    return (
        <Badge label={'MQTT: ' + label} color={color} className={className}/>
    );

}